import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

type SharedBillingRider = {
  residenceAccountContactName: string;
  residenceAccountContactEmail: string;
  residenceAccountId: Nullable<number>;
};

export const useResidenceAccountIdChanged = (originalSBRDetails: SharedBillingRider | null) => {
  const { watch, setError, clearErrors, formState } = useFormContext<{
    sharedBillingRider: {
      residenceAccountId: Nullable<number>;
      residenceAccountContactEmail: string;
      residenceAccountContactName: string;
    };
  }>();
  const residenceAccountId = watch('sharedBillingRider.residenceAccountId');
  const residenceAccountContactName = watch('sharedBillingRider.residenceAccountContactName');
  const residenceAccountEmail = watch('sharedBillingRider.residenceAccountContactEmail');

  const hasResidenceAccountContactEmailChanged =
    residenceAccountEmail !== originalSBRDetails?.residenceAccountContactEmail;
  const hasResidenceAccountContactNameChanged =
    residenceAccountContactName !== originalSBRDetails?.residenceAccountContactName;
  const hasResidenceAccountIdChanged = residenceAccountId !== originalSBRDetails?.residenceAccountId;

  useEffect(() => {
    if (!originalSBRDetails) {
      return;
    }
    if (
      hasResidenceAccountIdChanged &&
      !hasResidenceAccountContactEmailChanged &&
      !hasResidenceAccountContactNameChanged
    ) {
      setError('sharedBillingRider.residenceAccountContactName', { message: 'Please update Contact Name' });
      setError('sharedBillingRider.residenceAccountContactEmail', { message: 'Please update Contact Email Address' });
    }
    if (!hasResidenceAccountIdChanged && formState.errors.sharedBillingRider) {
      formState.errors.sharedBillingRider?.residenceAccountContactName &&
        clearErrors('sharedBillingRider.residenceAccountContactName');
      formState.errors.sharedBillingRider?.residenceAccountContactEmail &&
        clearErrors('sharedBillingRider.residenceAccountContactEmail');
    }
  }, [hasResidenceAccountIdChanged]);

  useEffect(() => {
    if (!originalSBRDetails) {
      return;
    }
    if (hasResidenceAccountContactNameChanged && hasResidenceAccountIdChanged) {
      clearErrors('sharedBillingRider.residenceAccountContactName');
    }
  }, [hasResidenceAccountContactNameChanged]);

  useEffect(() => {
    if (!originalSBRDetails) {
      return;
    }
    if (hasResidenceAccountContactEmailChanged && hasResidenceAccountIdChanged) {
      clearErrors('sharedBillingRider.residenceAccountContactEmail');
    }
  }, [hasResidenceAccountContactEmailChanged]);
};
